import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './styles/admin-theme.css';
import { 
  trackWebVitals, 
  preloadCriticalResources, 
  registerServiceWorker,
  addResourceHints 
} from './utils/performance';

// Initialize performance optimizations
preloadCriticalResources();
addResourceHints();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Track Web Vitals for performance monitoring
trackWebVitals();

// Register service worker for caching
registerServiceWorker();
